<template>
  <help-dialog title="Generate workflows with AI" max-width="30%">
    <template #activator="{ props, openDialog }">
      <slot :props="props" :openDialog="openDialog"></slot>
    </template>

    <template #default>
      <h3>Get started quickly</h3>
      Use AI to generate a workflow with cards, read models, commands and entities enabling you to get started quickly.
      <br /><br />
      <h3>Enter the prompt</h3>
      Describe a business process or a project scope. For example: "<b>A process for ordering home delivery of food in 5 steps</b>".
      <br /><br />
      <h3>Cards</h3>
      Specify which card types to generate cards for in every step of the workflow.
      You can configure card types in the settings
      (the <v-icon size="x-small">mdi-cog</v-icon> icon top right).
      <br /><br />
      <h3>Commands</h3>
      If you want to add fields to Commands, check <b>Generate Command Attributes with AI</b>
      <br /><br />
      <h3>Entities</h3>
      If you want to generate Entities, check <b>Generate Entities with AI</b>
      <br /><br />
      <h3>Read models</h3>
      If you want to add fields to Read Models, check <b>Generate Read Model Attributes with AI</b>
      <br /><br />

      <h3>Generate workflow</h3>
      Press <b>Generate workflow</b>. This may take up to a few minutes.
      NOTE: The more example data and cards you generate, the longer it will take.
      After the workflow is created, you can add additional events and cards with
      AI one by one. To generate a complete workflow with AI, you must start from
      an empty workflow.
      <br /><br />

      <h3>AI models</h3>
      You can choose from several AI models in the workflow settings.
      <br /><br />

      <h3>Note</h3>
      When adding events to an existing workflow or asking questions,
      information about your current workflow will be shared with OpenAI.
      <br /><br />

      <p class="text-grey-darken-4">
        For a complete walkthrough of Domain-Driven Design in Qlerify,
        <a
          href="https://www.qlerify.com/domain-driven-design#toc-step-2:-generate-with-ai"
          target="_blank"
          class="text-blue-accent-4"
        >
          click here
        </a>.
      </p>
    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  },
  props: ['openedFromSettings'],
  data () {
    return {
      open: false
    }
  }
}
</script>
